import React from 'react';
import PropTypes from 'prop-types';

export default class HiddenField extends React.Component {
    render() {
        const {
            id,
            required,
            inputValue
        } = this.props;

        return (
            <input
                type="hidden"
                id={ id }
                required={ required }
                disabled={ true }
                value={ inputValue || '' }
            />
        );
    }
}

HiddenField.propTypes = {
    id: PropTypes.string.isRequired,
    required: PropTypes.bool,
    inputValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

HiddenField.defaultProps = {
    required: false,
    inputValue: ''
};
